import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import './Notices.css'
import PageTitle from '../components/UI/PageTitle'
import { getAnnouncements } from '../api/Index'
import Separator from '../components/UI/Separator'
import { CiEdit } from 'react-icons/ci'
import { useAuth } from '../api/Authcontext'

const Notices = () => {
  const navigate = useNavigate();
  const { userData } = useAuth();
  const [notices, setNotices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchNotices = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await getAnnouncements();
        console.log('Notices response:', response);
        
        // Handle different possible response structures
        let noticesData = response.data;
        if (!Array.isArray(noticesData)) {
          // If response.data is not an array, check if it's nested
          if (noticesData && Array.isArray(noticesData.announcements)) {
            noticesData = noticesData.announcements;
          } else if (noticesData && Array.isArray(noticesData.data)) {
            noticesData = noticesData.data;
          } else {
            // If still not an array, initialize as empty array
            noticesData = [];
          }
        }
        
        setNotices(noticesData);
      } catch (err) {
        setError(err.message);
        console.error('Error fetching notices:', err);
        setNotices([]); // Set empty array on error
      } finally {
        setLoading(false);
      }
    };

    fetchNotices();
  }, []);

  const handleEditNotice = (noticeId) => {
    navigate(`/edit-notice?id=${noticeId}`);
  };

  const NoticeCard = ({ notice }) => {
    const formatDate = (dateString) => {
      if (!dateString) return 'Not available';
      return new Date(dateString).toLocaleDateString();
    };

    return (
      <div>
        <div className="notice-profile-container">
          <div className="notice-details">
            <h4>{notice.title}</h4>
            <div className='notice-info'>
              <p className="notice-content">{notice.content || notice.description}</p>
              <p>Created At: {formatDate(notice.createdAt)}</p>
              <p>Expires At: {formatDate(notice.expiresAt || notice.endDate)}</p>
            </div>
          </div>
          <div>
            <p className="notice-status">{notice.importance}</p>
          </div>
        </div>
        {userData?.role === 'admin' && (
          <button onClick={() => handleEditNotice(notice._id || notice.id)}>
            <CiEdit />Edit
          </button>
        )}
      </div>
    );
  }


  if (loading) {
    return (
      <div>
        <PageTitle title="Notices" />
        <div>Loading notices...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div>
        <PageTitle title="Notices" />
        <div style={{color: 'red'}}>Error: {error}</div>
      </div>
    );
  }

  return (
    <div>
      <PageTitle title="Notices" />
      <div className="notices-profile-container">
        {!Array.isArray(notices) || notices.length === 0 ? (
          <div>No notices available.</div>
        ) : (
          notices.map(notice => (
            <>
            <Separator />
            <NoticeCard key={notice._id || notice.id} notice={notice} />
            </>
          ))
        )}
      </div>
    </div>
  )
}

export default Notices